import { IdentityService } from 'api/generated/services/IdentityService';
import { UseMutationOptions, useMutation } from 'react-query';

export type IdentityPasswordResetInput = {
  userCode: string;
  requestBody?: string;
};

export const useIdentityUsersPasswordResetInitMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof IdentityService.postIdentityUsersPasswordResetInit>>,
      unknown,
      {
        input: IdentityPasswordResetInput;
      },
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ input: input }) => IdentityService.postIdentityUsersPasswordResetInit(input.userCode, input.requestBody),
    {
      ...options
      // onSuccess: () => {
      //   toast.success('The code has been successfully sent on you email address.');
      // },
    }
  );
